import Page from '@averyano/core/src/classes/Page';
import ImageHoverEffect from '../../components/@avery-image-hover-effect';
import each from 'lodash/each';
// import GraphicDes from './GraphicDes';
import CoverSection from './cover-section.js';
import AboutSection from './about-section.js';

import ReprSection from './repr-section.js';
import ContactSection from './contact-section.js';
import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
export default class HomePage extends Page {
	constructor() {
		super({
			element: '.home',
			elements: {
				sectionVision: '.vision',
				sectionProcess: '.process',
				sectionBrandiden: '.brandiden',
			},
		});

		this.isMobile = window.matchMedia('(max-width: 999px)');
		this.id = 'home';
		this.isCreated = false;
	}

	create() {
		if (this.template != this.id) return;

		if (!this.isReady) super.createComponent();

		if (!this.isCreated) {
			this.components = {
				// selection: new ImageHoverEffect({
				// 	element: '.brandiden',
				// 	elements: {
				// 		figure: '.selection__figure',
				// 		content: [
				// 			{
				// 				image: '#brand-averyano',
				// 				button: '[data-select=averyano]',
				// 			},
				// 			{
				// 				image: '#brand-chuiko',
				// 				button: '[data-select=chuiko]',
				// 			},
				// 			// {
				// 			// 	image: '#brand-piano',
				// 			// 	button: '[data-select=piano]',
				// 			// },
				// 			// {
				// 			// 	image: '#brand-prelab',
				// 			// 	button: '[data-select=prelab]',
				// 			// },
				// 		],
				// 	},
				// 	activeClass: 'selection__image--active',
				// }),
				// graphicDes: new GraphicDes(),
				// cover: new CoverSection(),
				about: new AboutSection(),
				repr: new ReprSection(),
				contact: new ContactSection(),
			};
			this.isCreated = true;
		}

		// Create Components
		each(this.components, (component) => {
			console.log('create component', component);
			component.create();
		});

		// this.createScrollTrigger();
		console.log(`🔼 ${this.id} is created`);
	}

	createScrollTrigger = () => {
		// if (window.isMobile) return;

		this.components.repr.createTimeline();
		// ScrollTrigger.create({
		// 	trigger: this.elements.sectionVision,
		// 	start: 'top-=5% top',
		// 	pin: true,
		// 	pinSpacing: false,
		// });
	};

	show() {
		this.createScrollTrigger();
		this.components.about.show();
	}

	hide() {
		return new Promise((resolve) => {
			this.destroy();

			GSAP.to(this.element, {
				autoAlpha: 0,
				onComplete: resolve,
			});
		});
	}

	addEventListeners() {
		console.log('HomePage addEventListeners 🔥🔥');
		each(this.components, (component) => {
			component.addEventListeners();
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();

		each(this.components, (component) => {
			component.destroy();
		});

		// Removes scroll trigger instances
		const scrolltriggerElements = document.querySelectorAll('.pin-spacer');
		each(scrolltriggerElements, (pinSpacer) => {
			const parent = pinSpacer.parentElement;

			while (pinSpacer.firstChild) {
				parent.appendChild(pinSpacer.firstChild);
			}

			parent.removeChild(pinSpacer);
		});
	}

	update() {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.update();
	}

	updateMousePos(e) {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.updateMousePos(e);
	}

	onResize() {
		console.log('resize design');
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}
}
